// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnCon {
    margin-top: 18px;
    margin-bottom: -12px;

}

.btns {
    width: 14%;
    height: 6vh;
    font-size: 14px;
}

.dialog-content {
    margin: 0;
}

::ng-deep.cuppa-dropdown>.dropdown-list {
    position: absolute !important;
    z-index: 10000 !important;

}

::ng-deep.ng-dropdown-panel.ng-select-bottom {
    /* min-width: 558px;
    margin-left: 2px;
    margin-top: 2px
*/

    /* margin-left: 0.3%; */
    width:100%;
   /* margin-top: 3px; */
}

/*
::ng-deep.ng-dropdown-panel {

  width:678.6px !important;
 min-width: 678.6px !important;
 left: 428.3px !important ;
} */

::ng-deep .ng-dropdown-panel-items .scroll-host {
    width: 100%;
}

.ngSelectGroup {
    width: 43.3vw;

}

.multi-select {
    width:100% ;
}
`, "",{"version":3,"sources":["webpack://./src/app/users-management/user-working-hours/add-edit-user-working-hours/add-edit-user-working-hours.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,oBAAoB;;AAExB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;;AAE7B;;AAEA;IACI;;;CAGH;;IAEG,uBAAuB;IACvB,UAAU;GACX,qBAAqB;AACxB;;AAEA;;;;;;GAMG;;AAEH;IACI,WAAW;AACf;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".btnCon {\r\n    margin-top: 18px;\r\n    margin-bottom: -12px;\r\n\r\n}\r\n\r\n.btns {\r\n    width: 14%;\r\n    height: 6vh;\r\n    font-size: 14px;\r\n}\r\n\r\n.dialog-content {\r\n    margin: 0;\r\n}\r\n\r\n::ng-deep.cuppa-dropdown>.dropdown-list {\r\n    position: absolute !important;\r\n    z-index: 10000 !important;\r\n\r\n}\r\n\r\n::ng-deep.ng-dropdown-panel.ng-select-bottom {\r\n    /* min-width: 558px;\r\n    margin-left: 2px;\r\n    margin-top: 2px\r\n*/\r\n\r\n    /* margin-left: 0.3%; */\r\n    width:100%;\r\n   /* margin-top: 3px; */\r\n}\r\n\r\n/*\r\n::ng-deep.ng-dropdown-panel {\r\n\r\n  width:678.6px !important;\r\n min-width: 678.6px !important;\r\n left: 428.3px !important ;\r\n} */\r\n\r\n::ng-deep .ng-dropdown-panel-items .scroll-host {\r\n    width: 100%;\r\n}\r\n\r\n.ngSelectGroup {\r\n    width: 43.3vw;\r\n\r\n}\r\n\r\n.multi-select {\r\n    width:100% ;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
